module.exports = __webpack_public_path__ + "img/50.a69aa07c.jpg";